import React from 'react';
import { Link } from 'react-router-dom';
import { Crown, Lock, QrCode, Tag } from 'lucide-react';

/** Member offer on the merchant detail page: your tier's discount, or a locked teaser. */
export function OfferBanner({ m, isAuthenticated }) {
  if (!m?.has_offer) return null;
  const tier = m.viewer_tier;
  const upsell = tier === 'pro' && m.elite_discount_pct > m.pro_discount_pct;
  return (
    <div className="mb-8 rounded-2xl border border-[#00E676]/30 bg-gradient-to-r from-[#00E676]/10 to-[#00E5FF]/[0.04] p-5 sm:p-6 flex flex-col sm:flex-row sm:items-center gap-4" data-testid="merchant-offer-banner">
      <div className="flex items-center gap-4 flex-1 min-w-0">
        <div className="rounded-xl bg-[#00E676] text-[#000B18] px-4 py-3 text-center flex-shrink-0">
          <p className="font-outfit text-2xl font-bold leading-none" data-testid="merchant-offer-pct">{tier ? m.your_discount_pct : m.elite_discount_pct}%</p>
          <p className="text-[10px] font-semibold uppercase">{tier ? 'your discount' : 'up to'}</p>
        </div>
        <div className="min-w-0">
          {tier ? (
            <>
              <p className="text-white font-semibold">{m.offer_headline || `${m.your_discount_pct}% off for AGA ${tier === 'elite' ? 'Elite' : 'Pro'} members`}</p>
              <p className="text-xs text-[#A0B4CC] mt-1 flex items-center gap-1"><QrCode className="w-3.5 h-3.5" />Show your AGA membership card QR at checkout.</p>
              {m.offer_terms && <p className="text-[11px] text-[#5C7599] mt-1" data-testid="merchant-offer-terms">{m.offer_terms}</p>}
            </>
          ) : (
            <>
              <p className="text-white font-semibold flex items-center gap-1.5"><Lock className="w-4 h-4 text-[#FFD740]" />Members-only offer</p>
              <p className="text-xs text-[#A0B4CC] mt-1">Pro members get <b className="text-[#00E5FF]">{m.pro_discount_pct}%</b> · Elite members get <b className="text-[#FFD740]">{m.elite_discount_pct}%</b>. Free members can browse — upgrade to Pro or Elite to get the discount.</p>
            </>
          )}
          {upsell && (
            <p className="text-xs text-[#FFD740] mt-1 flex items-center gap-1" data-testid="merchant-offer-upsell"><Crown className="w-3.5 h-3.5" />Elite members get {m.elite_discount_pct}% here.</p>
          )}
        </div>
      </div>
      {!tier && (
        <Link to={isAuthenticated ? '/my-plan' : '/register'} className="rounded-full bg-[#00E676] text-[#000B18] font-semibold px-5 py-2.5 hover:bg-[#5BFFA0] transition-colors text-center flex items-center justify-center gap-1.5" data-testid="merchant-offer-join-btn">
          <Tag className="w-4 h-4" />{isAuthenticated ? 'Upgrade to unlock' : 'Join free'}
        </Link>
      )}
      {upsell && (
        <Link to="/my-plan" className="rounded-full border border-[#FFD740]/50 text-[#FFD740] px-4 py-2 text-sm hover:bg-[#FFD740]/10 transition-colors text-center" data-testid="merchant-offer-upgrade-btn">Upgrade to Elite</Link>
      )}
    </div>
  );
}
